<template>
  <!-- 团险活动 -->
  <div class="page-container">
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202503/04/p_01.jpg" />
    </div>
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202503/04/p_02.jpg" />
    </div>
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202503/04/p_03.jpg" />
    </div>
  </div>
</template>

<script>
import config from '@/api/common';
import activityRules from '@/components/okActivity/rulePopup';

export default {
  components: {
    activityRules
  },
  data() {
    return {
      activityList: [],
      preview: false,
    };
  },

  created() {
    this.preview = this.$route.query.preview ? true : false;
    if (this.$route.query.preview) return;

  },

  methods: {
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  .container {
    position: relative;
    .img {
      width: 750px;
      display: block;
    }
    .rule-icon {
      width: 150px;
      height: 100%;
      position: absolute;
      right: 0;
      bottom: 0;
    }
    .detail-icon {
      width: 64px;
      height: 64px;
      position: absolute;
      right: 20px;
      bottom: 0;
    }
    .detaile {
      width: 500px;
      height: 102px;
      position: absolute;
      bottom: 30px;
      left: 50%;
      margin-left: -250px;
      border-radius: 51px;
    }
    .product-btn {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
